import * as React from "react";
import HeaderButton from "src/components/Buttons/HeaderButton";
import SideDrawer from "src/components/Navigation/SideDrawer";
import Social from "src/components/Navigation/Social";
import { Colors, IHeaderComponent, IText } from "src/ScrollyInterface";
import { setStyles } from "src/shared/breakpoints";
import "./Header.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const headerComponent = (props: IHeaderComponent) => {
  const {
    breakpoint,
    contentId,
    header,
    links,
    navImages,
    navType,
    onToggleSideDrawer,
    showSideDrawer
  } = props;

  const toggleSwipeHandler = () => {
    onToggleSideDrawer(!showSideDrawer);
  };

  const generateStyles = (defaultContent: IText) => {
    return defaultContent && defaultContent.letter_spacing
      ? {
        letterSpacing: setStyles(
          {
            default: defaultContent.letter_spacing,
            tabletSm: "0px"
          },
          breakpoint
        )
      }
      : {};
  };

  const backButtonStyle = showSideDrawer ? { display: "none" } : {};

  const backButtonStroke =
    header && header.color
      ? { stroke: header.color }
      : { stroke: Colors.white };

  return (
    <div className="Header-container">
      <div className="Header-subcontainer">
        <div className="Header-buttons">
          <a href={links.portal} target="_self" style={backButtonStyle}>
            <FontAwesomeIcon
              className="Header-back-button"
              icon="arrow-alt-circle-left"
              style={backButtonStroke}
            />
          </a>
          <HeaderButton
            header={header}
            links={links}
            styles={generateStyles(header)}
            showSideDrawer={showSideDrawer}
          />
        </div>
        <div className="Header-social">
          <Social links={links} navType={navType.desktop} />
        </div>
        <div className="Header-hamburger" onClick={toggleSwipeHandler}>
          <FontAwesomeIcon className="Header-fa-hamburger" icon="bars" />
        </div>
        <SideDrawer
          open={showSideDrawer}
          closed={toggleSwipeHandler}
          contentId={contentId}
          links={links}
          navImages={navImages}
          navType={navType.mobile}
        />
      </div>
    </div>
  );
};

export default headerComponent;



// WEBPACK FOOTER //
// ./src/components/Marginals/Header.tsx